<template>
  <div class="container-fluid">
    <div class="text-right mb-2">
      {{ reloadTime }}
      <el-button
        type="danger"
        size="small"
        @click="clearTipDialogVisible = true"
        >清除跨日資料</el-button
      >
    </div>
    <div class="fixed-list-item">
      <eva-icon fill="#000" name="refresh-outline" @click="reload" />
    </div>
    <div class="row" style="cursor: default">
      <div class="col-md-2">
        <draggable
          class="list-group unselect-block"
          :list="roomList.WaitArranges"
          :sort="false"
          group="people"
          @add="onAdd($event, null)"
        >
          <div
            class="p-item"
            v-for="(person, index) in roomList.WaitArranges"
            :key="index"
          >
            <el-tooltip
              effect="dark"
              :content="
                person.PreAssignRoom && person.PreAssignRoom.Name
                  ? person.PreAssignRoom.Name
                  : null
              "
              placement="top-start"
            >
              <div class="i-wrap">
                {{ index + 1 }}-
                <template
                  v-if="person.PreAssignRoom && person.PreAssignRoom.Name"
                  >{{ person.PreAssignRoom.Name }}</template
                >
              </div>
            </el-tooltip>

            <el-tooltip
              effect="dark"
              :content="person.Name"
              placement="top-start"
            >
              <span
                class="name-link"
                :class="{
                  female: person.Sex && person.Sex === '女',
                  male: person.Sex && person.Sex === '男',
                }"
                @click="showDetailModal(person)"
                >{{ person.Name }}</span
              >
            </el-tooltip>
          </div>
        </draggable>
      </div>
      <div class="col-md-10">
        <div class="row">
          <div
            class="col-md-4 col-lg-3"
            v-for="(room, index) in roomList.Rooms"
            :key="index"
          >
            <div class="room-info">
              <el-tooltip
                effect="dark"
                :content="room.Name"
                placement="top-start"
              >
                <span class="room-name">{{ room.Name }}</span>
              </el-tooltip>

              <el-switch
                @change="enableChange($event, room)"
                v-model="room.IsEnabled"
                active-color="#5380f7"
                inactive-color="#CCC"
                :disabled="room.Arranged"
              >
              </el-switch>
            </div>
            <div class="room-block">
              <draggable
                v-if="room.IsEnabled"
                class="list-group"
                :list="room.Arrange"
                :group="{
                  name: 'people',
                  pull:
                    room.Arrange &&
                    room.Arrange.length > 0 &&
                    room.Arrange[0].StartTime,
                  put: !room.Arranged,
                }"
                @add="onAdd($event, room.Guid)"
              >
                <div
                  class="p-item"
                  v-for="(person, index) in room.Arrange"
                  :key="index"
                >
                  <el-tooltip
                    effect="dark"
                    :content="person.Name"
                    placement="top-start"
                  >
                    <span
                      class="name-link"
                      :class="{
                        female: person.Sex === '女',
                        male: person.Sex === '男',
                      }"
                      @click="showDetailModal(person)"
                      >{{ person.Name }}</span
                    >
                  </el-tooltip>

                  <div class="edit-block">
                    {{ person.StageName }}
                    <span v-if="person.StartTime">{{
                      person.StartTime | momentTime
                    }}</span>
                    <el-button
                      v-if="!person.StartTime"
                      @click="start(person.Guid, person.StageGuid)"
                      type="primary"
                      size="mini"
                      round
                      >開始</el-button
                    >
                    /

                    <el-button
                      v-if="person.StartTime"
                      @click="end(person.Guid, person.StageGuid)"
                      type="danger"
                      size="mini"
                      round
                      >結束</el-button
                    >

                    <div style="font-size: 0.85em; margin-top: 5px">
                      預計 {{ person.ExpectEndTime | momentTime }} 結束
                    </div>
                  </div>
                </div>
              </draggable>

              <div
                style="
                  padding: 3px 0px;
                  background-color: #db6a6a;
                  display: block;
                  color: #fff;
                  width: 98px;
                  margin: 16px auto;
                  border-radius: 25px;
                  font-size: 0.8em;
                "
                class="text-center"
                v-if="!room.IsEnabled"
              >
                <svg
                  width="15"
                  fill="#FFF"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                  <path
                    d="M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z"
                  />
                </svg>
                未啟用
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 各資訊總覽 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a>
              <span>
                <eva-icon name="person-outline" fill="#FFF"></eva-icon>
                履歷
              </span>
            </a>

            <div
              class="close-show-detail"
              @click.prevent="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              ></eva-icon>
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar class="page">
                <section class="page-inner">
                  <div class="title">
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="
                          $common.downloadResumePDF(
                            resumeDetail.ResumeType,
                            resumeDetail.ResumeId
                          )
                        "
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="resumeDetail.ResumeType === 'IDL'"
                    :ResumeId="resumeDetail.ResumeId"
                    :ResumeType="'IDL'"
                  />
                  <DlResume
                    v-if="resumeDetail.ResumeType === 'DL'"
                    :ResumeId="resumeDetail.ResumeId"
                    :ResumeType="'DL'"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>

    <!-- flow delete modal -->
    <el-dialog
      title="清除跨日資料"
      :visible.sync="clearTipDialogVisible"
      width="480px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="form-group">
        <span>是否確定刪除昨日以前的面談室安排?</span>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="clearTipDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="clearAssignRoom()">確定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* global $ */
import moment from "moment";
import draggable from "vuedraggable";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";

export default {
  name: "RoomManagement",

  components: {
    IdlResume,
    DlResume,
    draggable,
  },
  data() {
    return {
      interview: {},

      reloadTime: null, //重新刷新的時間

      resumeDetail: {},
      isShowDetail: false,

      isAddInterviewee: false,
      interviewee: {},
      roomList: [],

      clearTipDialogVisible: false, //清除跨日資料的確認視窗
    };
  },

  methods: {
    getAssignRoom() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.getAssignRoom()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.roomList = response.data.Data;
          }

          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    clearAssignRoom() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.clearAssignRoom()
        .then((response) => {
          if (response.data.ErrorMessage) {
            vm.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.getAssignRoom();
            vm.clearTipDialogVisible = false;
            vm.$notify({
              message: response.data.Data,
              type: "success",
            });
          }

          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    start(id, stageGuid) {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.roomStart(id, stageGuid)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.getAssignRoom();
            this.$notify({
              message: response.data.Data,
              type: "success",
            });
          }

          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    end(id, stageGuid) {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.roomEnd(id, stageGuid)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.getAssignRoom();
            this.$notify({
              message: response.data.Data,
              type: "success",
            });
          }

          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    reload() {
      //重新讀取
      const today = new Date();
      const hour = today.getHours();
      const min = today.getMinutes();
      const sec = today.getSeconds();

      // 轉成字串，如果低於10，前面加上'0'
      const hourString = hour < 10 ? "0" + hour : "" + hour;
      const minString = min < 10 ? "0" + min : "" + min;
      const secString = sec < 10 ? "0" + sec : "" + sec;

      this.reloadTime = hourString + ":" + minString + ":" + secString;
      this.getAssignRoom();
    },
    //結案
    close(person) {
      person.endTime = this.dayjs().format("HH:mm");
    },
    // 檢視履歷
    showDetailModal(person) {
      const vm = this;
      vm.resumeDetail = {
        ResumeType: person.ResumeType,
        ResumeId: person.ResumeId,
      };

      this.isShowDetail = true;
    },
    openDetail() {
      $("#interviewDataModel").modal("show");
    },

    enableChange(val, room) {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      let params = {
        roomGuid: room.Guid,
        isEnable: val,
      };
      vm.$api.InterviewSch.changeRoomStatus(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.getAssignRoom();
            this.$notify({
              message: response.data.Data,
              type: "success",
            });
          }

          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    intervieweeModal({ action, data }) {
      switch (action) {
        case "addInterviewee":
          this.interviewee = {};
          this.isAddInterviewee = true;
          break;
        case "editInterviewee":
          this.interviewee = { ...data };
          this.isAddInterviewee = false;
          break;
      }
      this.$refs.intervieweeData.reset();
      $("#intervieweeModal").modal("show");
    },

    // 日期不得小於今日
    disabledBeforeToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    onAdd(person, roomId) {
      const vm = this;
      let currentPerson = JSON.parse(
        JSON.stringify(person.item._underlying_vm_)
      );

      let params = {
        Guid: currentPerson.Guid,
        RoomGuid: roomId,
      };
      vm.$store.dispatch("updateLoading", true);

      vm.$api.InterviewSch.assignRoom(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            vm.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.getAssignRoom();
            vm.$notify({
              message: response.data.Data,
              type: "success",
            });
          }

          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },
  },

  filters: {
    momentTime: function (date) {
      if (date === null) {
        return null;
      } else {
        return moment(date).format("HH:mm");
      }
    },
  },

  created() {
    this.getAssignRoom();
  },
};
</script>

<style lang="scss" scoped>
.p-item {
  background-color: #fff;
  padding: 5px;
  border-radius: 5px;
  font-size: 0.9em;
  cursor: pointer;
  .i-wrap {
    height: 35px;
    padding: 0 10px;
    line-height: 35px;
    text-align: center;
    display: block;
    border-radius: 5px;
    width: 100%;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .name-link {
    font-weight: bold;
    display: block;
    background-color: #f8f2a0;
    margin-bottom: 5px;
    text-align: center;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding: 1px 15px;
    border-radius: 25px;
    cursor: pointer;

    &:last-child {
      margin-bottom: 0;
    }

    &.female {
      background-color: #ffd4d4;
    }
    &.male {
      background-color: #d9e3ff;
    }
  }
}
.room-info {
  display: flex;
  justify-content: space-between;
  .room-name {
    background-color: #dbe5ff;
    padding: 3px 15px;
    font-size: 0.85em;
    display: block;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
.unselect-block {
  //左邊選擇區塊
  border: 5px solid #dbe5ff;
  background-color: #dbe5ff;
  min-height: 200px;
}
.room-block {
  border: 5px solid #dbe5ff;
  background-color: #dbe5ff;
  margin-bottom: 20px;
  .list-group {
    min-height: 105px;
  }
}
</style>
